import { baseApi } from '@ibk/shared-config';
export const locationApi = baseApi.injectEndpoints({
    endpoints: build => ({
        getLocationsByOrganization: build.query({
            query: ({ organizationId }) => ({
                url: `/v1/party-service/organization/${organizationId}/locations`,
            }),
            providesTags: ['Base'],
        }),
        createLocation: build.mutation({
            query: ({ organizationId, location }) => ({
                url: `/v1/party-service/organization/${organizationId}/locations`,
                method: 'POST',
                body: location,
            }),
            invalidatesTags: ['Base'],
        }),
        updateLocation: build.mutation({
            query: ({ organizationId, locationId, location }) => ({
                url: `/v1/party-service/organization/${organizationId}/locations/${locationId}`,
                method: 'PUT',
                body: location,
            }),
            invalidatesTags: ['Base'],
        }),
    }),
    overrideExisting: false,
});
export const { useGetLocationsByOrganizationQuery, useCreateLocationMutation, useUpdateLocationMutation } = locationApi;
